import { Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';

@Component({
  selector: 'pixl-card4',
  imports: [
    MatCardModule
  ],
  templateUrl: './card4.component.html',
  styleUrl: './card4.component.scss'
})
export class Card4Component {

}
